import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SEOHead } from "@/components/seo/SEOHead";

// Layout
import { Layout } from "@/components/layout/Layout";

// Pages - Core
import HomePage from "@/pages/HomePage";
import ContactPage from "@/pages/ContactPage";
import InsightsPage from "@/pages/InsightsPage";
import NotFoundPage from "@/pages/NotFoundPage";

// Pages - Solutions
import SolutionsPage from "@/pages/SolutionsPage";
import DefenceCUASPage from "@/pages/DefenceCUASPage";
import ProtectiveSecurityPage from "@/pages/ProtectiveSecurityPage";
import PublicSafetyPage from "@/pages/PublicSafetyPage";
import CivilIntelligencePage from "@/pages/CivilIntelligencePage";

// Pages - Platforms
import PlatformsPage from "@/pages/PlatformsPage";
import AIAVPlatformPage from "@/pages/AIAVPlatformPage";
import HelaisPlatformPage from "@/pages/HelaisPlatformPage";
import AdvancedDevelopmentPage from "@/pages/AdvancedDevelopmentPage";

// Pages - Company
import CompanyPage from "@/pages/CompanyPage";
import CompanyStructurePage from "@/pages/CompanyStructurePage";
import IntellectualPropertyPage from "@/pages/IntellectualPropertyPage";

// Pages - Evidence
import EvidencePage from "@/pages/EvidencePage";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <SEOHead />
        <Routes>
          <Route element={<Layout />}>
            {/* Core Pages */}
            <Route index element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            
            {/* Solutions */}
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/solutions/defence-cuas" element={<DefenceCUASPage />} />
            <Route path="/solutions/protective-security" element={<ProtectiveSecurityPage />} />
            <Route path="/solutions/public-safety" element={<PublicSafetyPage />} />
            <Route path="/solutions/civil-intelligence" element={<CivilIntelligencePage />} />
            
            {/* Platforms - UAVSimNet and UrbanAnalytix link to external sites */}
            <Route path="/platforms" element={<PlatformsPage />} />
            <Route path="/platforms/ai-av" element={<AIAVPlatformPage />} />
            <Route path="/platforms/helais" element={<HelaisPlatformPage />} />
            <Route path="/platforms/advanced-development" element={<AdvancedDevelopmentPage />} />
            
            {/* Company */}
            <Route path="/company" element={<CompanyPage />} />
            <Route path="/company/structure" element={<CompanyStructurePage />} />
            <Route path="/company/intellectual-property" element={<IntellectualPropertyPage />} />
            
            {/* Evidence & Assurance */}
            <Route path="/evidence" element={<EvidencePage />} />
            
            {/* Legacy redirects for old URLs */}
            <Route path="/about" element={<Navigate to="/company" replace />} />
            <Route path="/our-companies" element={<Navigate to="/company/structure" replace />} />
            <Route path="/defence" element={<Navigate to="/solutions/defence-cuas" replace />} />
            <Route path="/defence/ai-av" element={<Navigate to="/platforms/ai-av" replace />} />
            <Route path="/defence/helais" element={<Navigate to="/platforms/helais" replace />} />
            <Route path="/technologies" element={<Navigate to="/platforms" replace />} />
            <Route path="/intellectual-property" element={<Navigate to="/company/intellectual-property" replace />} />
            
            {/* External redirects - these would normally redirect externally but React Router handles internally */}
            <Route path="/platforms/uavsimnet" element={<Navigate to="/platforms" replace />} />
            <Route path="/platforms/urbananalytix" element={<Navigate to="/platforms" replace />} />
            <Route path="/technologies/urbananalytix" element={<Navigate to="/platforms" replace />} />
            
            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
